import BusinessConstants from "../../../constant/BusinessConstants";
import ArchiveSvg from "../../../asset/icon/360Archive.svg";
import MediGroupSvg from "../../../asset/icon/MediGroup.svg";
import PaiBanSvg from "../../../asset/icon/PaiBan-weihui.svg";
import ZhiLiangJianChaSvg from "../../../asset/icon/ZhiLiangJianCha-weihui.svg";
import BuLiangShiJianSvg from "../../../asset/icon/BuLiangShiJian-weihui.svg";
import PeiXunSvg from "../../../asset/icon/PeiXun-weihui.svg";
import HuLiRiChangSvg from "../../../asset/icon/HuLiRiChang-weihui.svg";
import WTJCSvg from "../../../asset/icon/WTJC.svg";

const iconCompMap = {
    [BusinessConstants.UNDERLAY_APP_MODULE_TYPE.ARCHIVE]: ArchiveSvg,
    [BusinessConstants.UNDERLAY_APP_MODULE_TYPE.MED_GROUP]: MediGroupSvg,
    [BusinessConstants.UNDERLAY_APP_MODULE_TYPE.ZLJC]: ZhiLiangJianChaSvg,
    [BusinessConstants.UNDERLAY_APP_MODULE_TYPE.BLSJ]: BuLiangShiJianSvg,
    [BusinessConstants.UNDERLAY_APP_MODULE_TYPE.PAIBAN]: PaiBanSvg,
    [BusinessConstants.UNDERLAY_APP_MODULE_TYPE.PEIXUN]: PeiXunSvg,
    [BusinessConstants.UNDERLAY_APP_MODULE_TYPE.HULIRICHANG]: HuLiRiChangSvg,
    [BusinessConstants.UNDERLAY_APP_MODULE_TYPE.USER_TRANSFER]: HuLiRiChangSvg,
    [BusinessConstants.UNDERLAY_APP_MODULE_TYPE.WTJC]: WTJCSvg,
};

export default iconCompMap;
